<template>
  <div class="yCenter totalAmountStyle">
    <div class="taxFreeStyle">
      <v-row no-gutters>
        <v-col>
          {{ $t('common.input_subtotal-tax-exempt') + ':' + totalList.taxFree }}
        </v-col>
      </v-row>
    </div>
    <div class="tax10Style">
      <v-row no-gutters class="py-1">
        <v-col>
          {{
            $t('common.input_subtotal-for-10-percent') +
            ':' +
            totalList.tax10.totalAmount
          }}
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1">
        <v-col>
          {{ $t('common.input_consumption-tax-10-percent') + ':' }}
          <span v-if="readonly"> {{ totalList.tax10.tax }} </span>
          <div v-else class="textStyle">
            <v-text-field
              v-model="totalList.tax10.tax"
              outlined
              dense
              hide-details
              height="28"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="tax8Style">
      <v-row no-gutters class="py-1">
        <v-col>
          {{
            $t('common.input_subtotal-for-eight-percent') +
            ':' +
            totalList.tax8.totalAmount
          }}
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1">
        <v-col>
          {{ $t('common.input_consumption-tax-8-percent') + ':' }}
          <span v-if="readonly"> {{ totalList.tax8.tax }} </span>
          <div v-else class="textStyle">
            <v-text-field
              class="textStyle"
              v-model="totalList.tax8.tax"
              outlined
              dense
              hide-details
              height="28"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="discountStyle">
      <v-row no-gutters class="py-1">
        <v-col class="d-flex align-center">
          {{ $t('common.input_discount') }}
          <span v-if="readonly"> {{ totalList.discount }} </span>
          <div v-else class="textStyle">
            <v-text-field
              v-model="totalList.discount"
              outlined
              dense
              hide-details
              height="28"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="py-1">
        <v-col class="d-flex align-center">
          {{ $t('common.input_postage') }}
          <span v-if="readonly"> {{ totalList.shipping }} </span>
          <div v-else class="textStyle">
            <v-text-field
              v-model="totalList.shipping"
              outlined
              dense
              hide-details
              height="28"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="amountStyle">
      <v-row no-gutters>
        <v-col class="yCenter">
          {{ $t('common.input_total') }}
          <span class="font-weight-bold totalAmountFontSize">
            {{ totalList.totalAmount }}
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="yCenter submitBtn">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    readonly: { default: false },
    value: {
      taxFree: Number,
      tax10: { totalAmount: Number, tax: Number },
      tax8: { totalAmount: Number, tax: Number },
      discount: Number,
      shipping: Number,
      totalAmount: Number
    }
  },
  data: () => ({}),
  computed: {
    totalList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.totalAmountStyle {
  height: 100%;
  width: 100%;
  font-size: 13px;
}
.textCenterStyle {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.textStyle {
  width: 67px;
}
.taxFreeStyle {
  min-width: 17%;
}
.tax10Style {
  min-width: 15.5%;
}
.tax8Style {
  min-width: 15.5%;
}
.discountStyle {
  min-width: 10%;
}
.amountStyle {
  min-width: 17%;
  .totalAmountFontSize {
    font-size: 20px;
  }
}
.submitBtn {
  min-width: 15%;
}
</style>
